module.exports = __webpack_public_path__ + "static/grouped-bar-72964d3b05adbc62b9bcfcb60dbc97c2.png";